import React__default from 'react';
import './Tag.scss';

const Tag = ({ children, className, variant = 'pill', accent = 'neutral', size = 'large', appearance = 'solid', indicator = true, icon, iconSide = 'left', shadow = false, elevation, }) => {
    const shouldShowIndicator = indicator && (!icon || !['left', 'both'].includes(iconSide));
    const iconElement = icon ? (React__default.createElement("div", { className: 'tag-icon--rev', "aria-hidden": true }, icon)) : null;
    return (React__default.createElement("span", { className: className, "data-rev-component": 'tag', "data-rev-variant": variant, "data-rev-shadow": shadow ? 'true' : undefined, "data-rev-accent": accent, "data-rev-size": size, "data-rev-elevation": elevation, "data-rev-appearance": appearance },
        shouldShowIndicator && React__default.createElement("span", { className: 'tag-indicator--rev' }),
        ['left', 'both'].includes(iconSide) && iconElement,
        children,
        ['right', 'both'].includes(iconSide) && iconElement));
};

export { Tag };
//# sourceMappingURL=Tag.js.map
